import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { Label } from '../../components/widgets';
import css from './StepCard.css';

const StepCard = ({
    title = '',
    titleTextReplace = {},
    description = '',
    descriptionTextReplace = {},
    info = '',
    infoTextReplace = {},
    highlightInfo = false,
    className = '',
    contentClassName = '',
    titleClassName = '',
    titleRowClassName = '',
    headerChildren = null,
    titleAdornment = null,
    collapsible = false,
    defaultCollapsed = false,
    children,
}) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);

    const toggleCollapsed = () => setCollapsed(prev => !prev);

    const header = (
        <div
            className={classNames(css.header, { [css.collapsibleHeader]: collapsible })}
            onClick={collapsible ? toggleCollapsed : undefined}
        >
            <div className={css.titleArea}>
                {collapsible && (
                    <Icon
                        name={collapsed ? 'chevron-down' : 'chevron-up'}
                        size={IconSizes.SMALL}
                        variant={IconVariants.LIGHT}
                    />
                )}
                <div className={css.titleWrapper}>
                    <div className={classNames(css.titleRow, titleRowClassName)}>
                        {title && (
                            <Label
                                text={title}
                                textReplace={titleTextReplace}
                                type="subtitle"
                                className={classNames(css.title, titleClassName)}
                            />
                        )}
                        {titleAdornment}
                        {info && (
                            <>
                                <Icon name="point" size={IconSizes.X_SMALL} className={css.dot} />
                                <Label
                                    text={info}
                                    textReplace={infoTextReplace}
                                    type="p"
                                    className={classNames(css.info, { [css.infoHighlighted]: highlightInfo })}
                                />
                            </>
                        )}
                    </div>
                    {description && <Label text={description} textReplace={descriptionTextReplace} type="p" />}
                </div>
            </div>
            {headerChildren}
        </div>
    );

    const showDivider = !collapsible || !collapsed;

    return (
        <div className={classNames(css.card, className)}>
            {header}
            {showDivider && <div className={css.divider} />}
            <div className={classNames(css.content, contentClassName)}>{!(collapsible && collapsed) && children}</div>
        </div>
    );
};

StepCard.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    headerChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    title: PropTypes.string,
    titleTextReplace: PropTypes.object,
    descriptionTextReplace: PropTypes.object,
    description: PropTypes.string,
    info: PropTypes.string,
    infoTextReplace: PropTypes.object,
    highlightInfo: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    titleClassName: PropTypes.string,
    titleRowClassName: PropTypes.string,
    titleAdornment: PropTypes.node,
    collapsible: PropTypes.bool,
    defaultCollapsed: PropTypes.bool,
};

export default StepCard;
